import { render, staticRenderFns } from "./MediaData.vue?vue&type=template&id=73aa3422&scoped=true"
import script from "./MediaData.vue?vue&type=script&lang=js"
export * from "./MediaData.vue?vue&type=script&lang=js"
import style0 from "./MediaData.vue?vue&type=style&index=0&id=73aa3422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa3422",
  null
  
)

export default component.exports